//@flow
import { AccordionCard } from '@boi/core/lib';
import type { Node } from 'react';
import React, { useState } from 'react';

import SummaryRow from './SummaryRow';

const className = 'p-HomeQuoteSummaryPage';

type Props = {
  id?: string,
  label?: string,
  rows?: any,
  type?: string,
  heading?: string,
  children: Node,
  status?: string
};

const showHeading = (heading: string) => {
    return heading.length > 0 ? (
                    <div>
                        {heading}
                    </div>
                ) : ('');
}

const SummaryAccordion = (props: Props) => {
    const { 
        id = 'accordion', 
        label = 'Accordion', 
        rows = [], 
        type ='rows', 
        heading = '', 
        children, 
        status = 'success' 
    } = props;

    const [ isVisible, setIsVisible ] = useState(false)
    
    return (
        <AccordionCard
            id={`QuoteSummary__${id}`}
            label={label}
            childContainerClass={`${className}__noPaddingFormContainer`}
            isOnState={isVisible}
            status={status}
            handleToggle={() => {
                setIsVisible(!isVisible)
            }}
        >
            <div className={`c-Summary__container`}>
                {showHeading(heading)}
                {type === 'list' && (
                    <ul>
                        {rows.map((row: any, idx: number) => (
                            <SummaryRow key={idx} type={type} label={row.label} value={`${row.unit?.length > 0 ? row.unit : ''} ${row.value}`} />
                        ))}
                    </ul>
                )}
                {type === 'rows' && rows.map((row: any, idx: number) => (
                    <SummaryRow key={idx} type={type} label={row.label} value={`${row.unit?.length > 0 ? row.unit : ''} ${row.value}`} />
                ))}
                {children && (
                    <>
                        {children}
                    </>
                )}
            </div>
        </AccordionCard>
    );
}

export default SummaryAccordion;